'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { useBodyScrollLock } from '@common/hooks';
import SvgDelete from '@common/icon/SvgDelete';
import SvgHamburger from '@common/icon/SvgHamburger';
import { AnimatePresence, motion } from 'framer-motion';
import { useCallback, useEffect, useState } from 'react';
import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { FlutterInAppWebViewWindow } from '@/modules/wello-app';
import { useDeviceInfoStoreApi } from '@/stores/DeviceStore';
import { ServiceShortcutPopoverContent } from './ServiceShortcutPopoverContent';
interface ServiceShortcutFullScreenModalProps {
  open: boolean;
  onClose: () => void;
}
export const ServiceShortcutFullScreenModal = t0 => {
  const $ = _c(14);
  const {
    open,
    onClose
  } = t0;
  useBodyScrollLock(open);
  const deviceInfoStore = useDeviceInfoStoreApi();
  let t1;
  let t2;
  if ($[0] !== onClose || $[1] !== open) {
    t1 = () => {
      if (!open) {
        return;
      }
      const handleKeyDown = e => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t2 = [open, onClose];
    $[0] = onClose;
    $[1] = open;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== deviceInfoStore || $[5] !== onClose || $[6] !== open) {
    t3 = () => {
      if (!open) {
        return;
      }
      const appRouter = (window as FlutterInAppWebViewWindow).router;
      const previousBack = appRouter?.back;
      if (appRouter) {
        appRouter.back = onClose;
      }
      const unsubscribeExitModal = deviceInfoStore.subscribe((state, previousState) => {
        const isExitModalOpening = state.appModal.isOpened && state.appModal.type === "exit" && !previousState.appModal.isOpened;
        if (!isExitModalOpening) {
          return;
        }
        state.setAppModal({
          isOpened: false,
          type: "exit"
        });
        onClose();
      });
      return () => {
        if (appRouter && previousBack) {
          appRouter.back = previousBack;
        }
        unsubscribeExitModal();
      };
    };
    t4 = [deviceInfoStore, open, onClose];
    $[4] = deviceInfoStore;
    $[5] = onClose;
    $[6] = open;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== onClose || $[10] !== open) {
    t5 = open ? <motion.div role="dialog" aria-modal="true" aria-label={"\uC11C\uBE44\uC2A4 \uBC14\uB85C\uAC00\uAE30"} className="fixed inset-0 z-50 flex flex-col bg-Gray-white" initial={{
      opacity: 0,
      y: "4%"
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: "4%"
    }} transition={{
      duration: 0.2,
      ease: "easeInOut"
    }}><header className="flex min-h-56 items-center px-20"><button type="button" onClick={onClose} className="flex size-24 items-center justify-center" aria-label={"\uB2EB\uAE30"}><SvgDelete className="size-24 text-Gray-900" /></button><h2 className="flex-1 text-center font-600 text-Gray-900 typo-body1">바로가기</h2><div className="size-24" /></header><div className="flex-1 overflow-auto"><ServiceShortcutPopoverContent onNavigate={onClose} contentClassName="pt-0 px-0" termsDrawerMode="bottom" closeOnTermsOpen={false} /></div></motion.div> : null;
    $[9] = onClose;
    $[10] = open;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <Portal renderTo={getMainWrapperElement}><AnimatePresence>{t5}</AnimatePresence></Portal>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export const MobileServiceShortcutButton = () => {
  const $ = _c(8);
  const [menuOpen, setMenuOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setMenuOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const openMenu = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setMenuOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeMenu = t1;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t2;
  let t3;
  if ($[2] !== isDesktop) {
    t2 = () => {
      if (isDesktop) {
        setMenuOpen(false);
      }
    };
    t3 = [isDesktop];
    $[2] = isDesktop;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgHamburger className="size-24" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== menuOpen) {
    t5 = <><button type="button" aria-label={"\uC804\uCCB4 \uBA54\uB274"} aria-expanded={menuOpen} onClick={openMenu} className="flex size-26 shrink-0 items-center justify-center p-0 text-Gray-700 transition-colors hover:text-Gray-900">{t4}</button><ServiceShortcutFullScreenModal open={menuOpen} onClose={closeMenu} /></>;
    $[6] = menuOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};